import { useContext } from 'react';
import { ApiContext } from 'common/context/ApiContext';

export const useApi = () => {
  const context = useContext(ApiContext);
  return context.Api;
};
